var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2330_235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15226 1.22514C8.72113 1.22514 9.17879 1.6828 9.17879 2.25167V14.57C9.17879 15.1389 8.72113 15.5966 8.15226 15.5966H3.01961C2.45074 15.5966 1.99308 15.1389 1.99308 14.57V2.25167C1.99308 1.6828 2.45074 1.22514 3.01961 1.22514H8.15226ZM10.2053 2.25167C10.2053 1.11821 9.28572 0.198608 8.15226 0.198608H3.01961C1.88615 0.198608 0.966553 1.11821 0.966553 2.25167V14.57C0.966553 15.7035 1.88615 16.6231 3.01961 16.6231H8.15226C9.28572 16.6231 10.2053 15.7035 10.2053 14.57V2.25167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66553 0.711995C8.66553 0.4297 8.43456 0.19873 8.15226 0.19873H7.38236C7.17706 0.19873 6.98031 0.279997 6.83916 0.425423C6.69373 0.570848 6.61247 0.767599 6.61247 0.968628H4.55941C4.55941 0.763322 4.47814 0.56657 4.33272 0.425423C4.18729 0.279997 3.99054 0.19873 3.78951 0.19873H3.01961C2.73732 0.19873 2.50635 0.4297 2.50635 0.711995C2.50635 0.994291 2.73732 1.22526 3.01961 1.22526H3.5671C3.61414 1.40063 3.70397 1.56316 3.83656 1.69575C4.02903 1.88823 4.28994 1.99516 4.56368 1.99516H6.61247C6.88621 1.99516 7.14712 1.88823 7.33959 1.69575C7.47219 1.56316 7.56201 1.40063 7.60906 1.22526H8.15226C8.43456 1.22526 8.66553 0.994291 8.66553 0.711995Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2330_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.23877,
    height: 16.4245,
    fill: "white",
    transform: "matrix(-1 0 0 1 10.2053 0.198608)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.46c8889077c17edaac47abdc08065ab1.svg";
export { ForwardRef as ReactComponent };